module.exports = __webpack_public_path__ + "img/isracard-welcome-header.eff1da77.png";